import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { Coupon } from '@accounting/interfaces/coupon';
import CouponForm from '@accounting/components/forms/coupon-form/coupon-form.vue';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import BulkRecoverModal from '@shared/components/modals/bulk-recover-modal/bulk-recover-modal.vue';

library.add(faSync);

@Component({
  name: 'bpc-coupon-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-coupon-form': CouponForm,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-bulk-recover-modal': BulkRecoverModal,
  },
})
export default class CouponTable extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    stdCouponForm: InstanceType<typeof CouponForm> & {
      saveEntity(): void;
      setEntityAttributesAfterSave(): void;
    };
  };
  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;
  @Prop({ type: String, default: null }) readonly createFormConfigName: string;
  @Prop({ type: String, default: null }) readonly editFormConfigName: string;

  public entity: Coupon = null;
  public entityName = 'coupon';
  public pluralEntityName = 'coupons';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;
  public permissionEntityNameToUse = 'coupons';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  setEntityAttributesAfterSave() {
    this.$refs.stdCouponForm.setEntityAttributesAfterSave();
    this.showForm = true;
    this.showDrawerSection = true;
  }

  onFormSave() {
    this.nextAction = '';
    this.$refs.stdCouponForm.saveEntity();
  }

  onFormSaveAndNew() {
    this.nextAction = 'new';
    this.$refs.stdCouponForm.saveEntity();
  }

  get couponFormConfigName() {
    if (this.entity) {
      return this.editFormConfigName ? this.editFormConfigName : this.formConfigName;
    } else {
      return this.createFormConfigName ? this.createFormConfigName : this.formConfigName;
    }
  }

  // Bulk soft delete modal (move to trash)
  showBulkMoveToTrashModal = false;
  onBulkSoftDelete() {
    this.showBulkMoveToTrashModal = true;
  }
  onCLoseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }
  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
  }
  // Here, put the same fields as you put in dataToShowForBulkTrashedEntity in your entity Service
  bulkMoveToTrashDataToShow = [['code', 'name']];

  // Bulk restore modal (recover)
  showBulkRecoverModal = false;
  onBulkRecover() {
    this.showBulkRecoverModal = true;
  }
  onCLoseBulkRecover() {
    this.showBulkRecoverModal = false;
  }
  onSuccessBulkRecover() {
    this.$refs.provider.getEntities();
  }
  bulkRecoverDataToShow = [['code', 'name']];

  /* Lifecycle hooks */

  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
